import React, { useEffect, useState } from "react";
import "./banner.css";

const Banner = ({ page }) => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    fetch(`https://admin.mythsegypttours.com/api/banners/${page}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Banner API response:", data); // debug log
        setBanner(data.data); // خد الـ data اللي جوا
      })
      .catch((err) => console.error("Error loading banner:", err));
  }, [page]);

  if (!banner) return null;

  return (
    <section className={`banner banner-${page}`}>
      {banner.type === "image" ? (
        <img src={banner.file_url} alt={page} className="backgroundImg" />
      ) : (
        <video
          src={banner.file_url}
          className="backgroundImg"
          autoPlay
          muted
          loop
          playsInline
        />
      )}

      <div className="overlay"></div>

      <div className="bannerContent">
        <h1 className="mainTitle">{banner.title}</h1>
        <p className="subTitle">{banner.subtitle}</p>
      </div>
    </section>
  );
};

export default Banner;
